import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { FaSpinner } from 'react-icons/fa';
import { browserHistory } from 'react-router';

import { primary_dark15, primary_light } from '../../shared/lib/colors';
import { loadProductsByCategory } from '../../../redux/modules/products';
import {
  getCategoryType,
  getCategoryName,
  getSubcategoryName,
  getCategoryDescription,
  getSubcategoryDescription,
} from '../../../redux/modules/categories';
import connectDataFetchers from '../../shared/lib/connectDataFetchers.js';
import LeftFilters from '../../shared/LeftFilters/LeftFilters';
import Breadcrumb from '../../shared/Breadcrumb/Breadcrumb';
import Pager from '../../shared/Pager/Pager';
import ProductThumbnail from '../../shared/ProductThumbnail/ProductThumbnail';
import A from '../../shared/Anchor/Anchor';
import { pushRemarketingEvent } from '../../shared/lib/gaEnhancedEcommerce';
import { ga4ViewItemList } from '../../shared/lib/ga4EnhancedEcommerce';
import { fkmxViewItemList } from '../../shared/lib/farmakomMetrics';
import { criteoViewList } from '../../shared/lib/criteo';
import { gtmToGa4ViewItemList } from '../../shared/lib/gtmEnhancedEcommerce.js';

import './Categoria.scss';
import { ImageDispatcher } from '../../shared/ImageDispatcher/ImageDispatcher.js';
import { cleanImage } from '../../../utils/images.js';

class Categoria extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showFilters: false,
    };
  }

  componentDidMount() {
    if (this.props.hasCriteo) {
      // const iubenda = new IubendaCookieSolution(
      //   this.props.hasIubendaCookieSolution
      // );
      // iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
      this.renderCriteoTag();
    }

    // REMARKETING DINAMICO
    if (this.props.hasDynamicRemarketing) {
      pushRemarketingEvent('category');
    }

    // TRACK LIST - GTM, GA4, FKMX
    if (
      [
        this.props.hasGoogleTagManager,
        this.props.hasGoogleAnalytics4Advanced,
        this.props.hasFarmakomMetrics,
      ].some(t => !!t)
    ) {
      this.trackItemsList();
    }

    if (!!this.props.redirect) {
      browserHistory.push(this.props.redirect);
    }
  }

  componentDidUpdate(oldProps) {
    if (this.props.loading !== oldProps.loading && !this.props.loading) {
      if (this.props.hasCriteo) {
        // const iubenda = new IubendaCookieSolution(
        //   this.props.hasIubendaCookieSolution
        // );
        // iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
        this.renderCriteoTag();
      }

      // REMARKETING DINAMICO
      if (this.props.hasDynamicRemarketing) {
        pushRemarketingEvent('category');
      }

      // TRACK LIST - GTM, GA4, FKMX
      if (
        [
          this.props.hasGoogleTagManager,
          this.props.hasGoogleAnalytics4Advanced,
          this.props.hasFarmakomMetrics,
        ].some(t => !!t)
      ) {
        this.trackItemsList();
      }
    }
    // if we have a redirect and it's different than before, push the new location
    if (!!this.props.redirect && this.props.redirect !== oldProps.redirect) {
      browserHistory.push(this.props.redirect);
    }
  }

  trackItemsList = () => {
    const {
      products,
      categoryType,
      categoryName,
      subcategoryName,
    } = this.props;

    const listInfo = {
      id: `${categoryType}_${categoryName}${
        subcategoryName ? '_' + subcategoryName : ''
      }`,
      name: `${categoryType} > ${categoryName}${
        subcategoryName ? ' > ' + subcategoryName : ''
      }`,
    };

    if (this.props.hasGoogleTagManager) {
      gtmToGa4ViewItemList(products, listInfo);
    }
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4ViewItemList(products, listInfo);
    }
    if (this.props.hasFarmakomMetrics) {
      fkmxViewItemList(products, listInfo);
    }
  };

  renderCriteoTag = async () => {
    // <!-- Criteo Category / Search / Listing Tag -->
    const email = (this.props.user && this.props.user.email) || '';
    const zipcode =
      (this.props.user &&
        this.props.user.shipping &&
        this.props.user.shipping.zipcode) ||
      '';

    criteoViewList(
      this.props.criteoAccountId,
      {
        email,
        zipcode,
      },
      this.props.products
    );
    // <!-- END Criteo Category / Search / Listing Tag -->
  };

  toggleFilters = event => {
    event.preventDefault();
    this.setState({
      showFilters: !this.state.showFilters,
    });
  };

  renderProducts(isMobile) {
    return (
      <div style={{ width: '100%' }}>
        {!isMobile && (
          <div className={'desktop'}>{this.renderProductsDesktop()}</div>
        )}
        {isMobile && (
          <div className={'mobile'}>{this.renderProductsMobile()}</div>
        )}
      </div>
    );
  }

  renderProductsDesktop = () => {
    const { categoryType, categoryName, subcategoryName } = this.props;

    const ga4ListInfo = {
      id: `${categoryType}_${categoryName}${
        subcategoryName ? '_' + subcategoryName : ''
      }`,
      name: `${categoryType} > ${categoryName}${
        subcategoryName ? ' > ' + subcategoryName : ''
      }`,
    };

    return (
      <div className={'desktop-container'}>
        {this.props.products.map(product => {
          return (
            <div className="col-sm-6 col-lg-4" key={product.id}>
              <ProductThumbnail
                product={product}
                list="Categoria"
                ga4ListInfo={ga4ListInfo}
              />
            </div>
          );
        })}
      </div>
    );
  };

  renderProductsMobile = () => {
    const { categoryType, categoryName, subcategoryName } = this.props;

    const ga4ListInfo = {
      id: `${categoryType}_${categoryName}${
        subcategoryName ? '_' + subcategoryName : ''
      }`,
      name: `${categoryType} > ${categoryName}${
        subcategoryName ? ' > ' + subcategoryName : ''
      }`,
    };

    return (
      <div>
        <div className={'mobile-container'}>
          {this.props.products.map((product, i) => {
            return (
              <div style={{ width: '48%' }}>
                <ProductThumbnail
                  key={product.id}
                  product={product}
                  list="Categoria"
                  spaceStar={6}
                  ga4ListInfo={ga4ListInfo}
                  lazy={i >= 4}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  render() {
    const { showFilters } = this.state;
    const { category, subcategory } = this.props.params;
    const {
      location,
      pagination,
      products,
      loading,
      categoryName,
      subcategoryName,
      categoryDescription,
      subcategoryDescription,
      siteName,
      logoImage,
      primaryColor,
      linkDrugsAuthorizedSite,
      linkDrugsAuthorizedSiteVet,
      uiVariantButton,
    } = this.props;

    const capitalizeFirst = string =>
      string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();

    const showDrugsAuthorization = products.some(
      product =>
        product.taxCreditType === 'DRUG' ||
        product.taxCreditType === 'HOMEOPATHY'
    );

    const showDrugsVetAuthorization = products.some(
      product => product.taxCreditType === 'VETERINARY_DRUG'
    );

    return (
      <div className={`categoria ${showFilters ? 'filters-open' : ''}`}>
        <Helmet
          title={`${categoryName} ${subcategoryName}`}
          meta={[
            {
              name: 'description',
              content: `${siteName} - Ecommerce Farmacia vendita ${categoryName} ${subcategoryName}`,
            },
            {
              name: 'keywords',
              content: `${categoryName}, ${subcategoryName}, ${siteName}, ecommerce, farmacia`,
            },
            {
              property: 'og:title',
              content: `${siteName} - Ecommerce Farmacia vendita ${categoryName} ${subcategoryName}`,
            },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:description',
              content: `${siteName} - Ecommerce Farmacia vendita online ${categoryName} ${subcategoryName}`,
            },
            { property: 'og:image', content: cleanImage(logoImage) },
          ]}
        />

        <div className="container">
          <LeftFilters
            category={category}
            subcategory={subcategory}
            location={location}
            sort={location.query.sort || 'sales'}
          />

          <div className="elenco-prodotti">
            <div className="pre-title">
              <A
                href="#"
                className="filter-toggle"
                onClick={this.toggleFilters}
              >
                {showFilters ? 'Nascondi filtri' : 'Mostra filtri'}
              </A>

              <Breadcrumb
                page={this.props.categoryType}
                category={this.props.params.category}
                subcategory={this.props.params.subcategory}
              />

              {products.length > 0 && (
                <Pager
                  location={location}
                  page={location.query.page || 1}
                  totalPages={pagination.totalPages}
                  sort={location.query.sort || 'sales'}
                  primaryColor={primaryColor}
                  uiVariantButton={uiVariantButton}
                />
              )}
            </div>

            <div
              className="page-title"
              style={{
                color: primary_dark15(primaryColor),
                backgroundColor: primary_light(primaryColor),
                borderRadius:
                  uiVariantButton === '1'
                    ? '12px'
                    : uiVariantButton === '3'
                    ? '30px'
                    : 0,
              }}
            >
              <div>
                {capitalizeFirst(this.props.subcategoryName) ||
                  capitalizeFirst(this.props.categoryName)}
                {loading && (
                  <span>
                    &nbsp;&nbsp;
                    <FaSpinner className="pulse" />
                  </span>
                )}
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                {showDrugsAuthorization && !!linkDrugsAuthorizedSite && (
                  <div>
                    <a
                      className="store-authorized-link"
                      href={linkDrugsAuthorizedSite}
                      target="_blank"
                    >
                      <ImageDispatcher
                        src="/static/images/logo_farmacia_autorizzata.png"
                        style={{ width: 60 }}
                      />
                    </a>
                  </div>
                )}
                {showDrugsVetAuthorization && !!linkDrugsAuthorizedSiteVet && (
                  <div>
                    <a
                      className="store-authorized-link"
                      href={linkDrugsAuthorizedSiteVet}
                      target="_blank"
                    >
                      <ImageDispatcher
                        src="/static/images/logo_farmacia_autorizzata_vet.png"
                        style={{ width: 60 }}
                      />
                    </a>
                  </div>
                )}
              </div>
            </div>

            <div className="category-description">
              {subcategoryDescription || categoryDescription}
            </div>

            {!loading && products.length > 0 && (
              <div>
                <div className="row">
                  {this.renderProducts(this.props.isMobile)}
                </div>

                <Pager
                  location={location}
                  page={location.query.page || 1}
                  totalPages={pagination.totalPages}
                  primaryColor={primaryColor}
                  isNew
                  uiVariantButton={uiVariantButton}
                />
              </div>
            )}

            {!loading && products.length === 0 && (
              <div className="no-results">
                <p>Nessun prodotto trovato in questa categoria.</p>
                <p>Prova a ricercare per parole chiave.</p>
              </div>
            )}
          </div>
          <div className="clearfix" />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isMobile: state.layout.isMobile,
    user: state.user.data,
    categoryType: getCategoryType(state, ownProps.params.category),
    categoryName: getCategoryName(state, ownProps.params.category),
    subcategoryName: getSubcategoryName(state, ownProps.params.subcategory),
    categoryDescription: getCategoryDescription(
      state,
      ownProps.params.category
    ),
    subcategoryDescription: getSubcategoryDescription(
      state,
      ownProps.params.subcategory
    ),
    pagination: state.products.pagination,
    products: state.products.data,
    loading: state.products.loading,
    redirect: state.products.redirect,
    siteName: state.store.data.datiFarmacia.siteName,
    logoImage: state.store.data.loghiTemplate.logoImage,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    uiVariantButton: state.store.data.uiVariants.buttons,
    linkDrugsAuthorizedSite:
      state.store.data.datiFarmacia.linkDrugsAuthorizedSite,
    linkDrugsAuthorizedSiteVet:
      state.store.data.datiFarmacia.linkDrugsAuthorizedSiteVet,
    hasCriteo: state.store.data.features.hasCriteo,
    hasDynamicRemarketing: state.store.data.features.hasDynamicRemarketing,
    hasIubendaCookieSolution:
      state.store.data.features.hasIubendaCookieSolution,
    criteoAccountId: state.store.data.integrazioni.criteo.accountId,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasGoogleTagManager: !!state.store.data.features.hasGoogleTagManager,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
  };
}

export default connect(mapStateToProps)(
  connectDataFetchers(Categoria, [loadProductsByCategory])
);
